export const MINI_GAMES_MUTED_KEY = 'myta.minigames.muted';
export const MINI_GAME_ACTIVE_WINDOW_MS = 20_000;
export const MINI_GAME_CLOCK_TICK_MS = 250;
export const MINI_GAMES_PICKER_ROOM_PX = 380;

export const MINI_GAMES_PLAY = 'Play a minigame';
export const MINI_GAMES_TUTORIAL = 'Teach me how to move';
export const MINI_GAMES_TUTORIAL_BADGE = 'Beta';
export const MINI_GAMES_KICKER = 'While you wait';
export const MINI_GAMES_FOOTER = 'The game pauses the moment you can enter.';
export const MINI_GAMES_NEW = 'New';

export const MINI_GAME_KICKER = 'Mini game';
export const MINI_GAME_TUTORIAL_KICKER = 'Tutorial';
export const MINI_GAME_SWITCH_LABEL = 'Switch game';
export const MINI_GAME_WARMING_UP = 'Warming up…';
export const MINI_GAME_FAILED_HEADLINE = 'This game couldn’t start';
export const MINI_GAME_FAILED_WEBGL =
  'Your browser can’t show 3D graphics right now. Your experience keeps loading as usual.';
export const MINI_GAME_FAILED_OTHER =
  'Something went wrong while loading it. Your experience keeps loading as usual.';
export const MINI_GAME_BACK = 'Back to loading';
export const MINI_GAME_ENTER = 'Enter experience';
export const MINI_GAME_KEEP_PLAYING = 'Keep playing';
export const MINI_GAME_SEAT_HELD = 'Your seat is held for';
export const MINI_GAME_SEAT_HELD_PLAYING = 'Your seat is held while you play';
export const MINI_GAME_MUTE = 'Mute';
export const MINI_GAME_UNMUTE = 'Unmute';
export const MINI_GAME_CLOSE = 'Close';
